import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import { InfoSnackBar } from "components/InfoSnackBar";
import { StyledButton } from "components/StyledButton";
import React from "react";

interface StatusMessageProps {
	success: string;
	failure: string;
}

export interface AlertDialogProps {
	title: string;
	message: string;
	open: boolean;
	onClose: () => void;
	confirmAction: () => Promise<boolean>;
	status: StatusMessageProps;
}

export const AlertDialog = ({
	open,
	onClose,
	confirmAction,
	title,
	message,
	status,
}: AlertDialogProps): JSX.Element => {
	const [snackOpen, setSnackOpen] = React.useState(false);
	const [isSuccess, setIsSuccess] = React.useState(true);

	const handleConfirm = async (): Promise<void> => {
		onClose();
		if (await confirmAction()) {
			setIsSuccess(true);
		} else {
			setIsSuccess(false);
		}
		setSnackOpen(true);
	};

	const handleSnackClose = (
		event?: React.SyntheticEvent,
		reason?: string,
	): void => {
		if (reason === "clickaway") {
			return;
		}

		setSnackOpen(false);
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={onClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{message}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<StyledButton onClick={onClose} color="secondary">
						Cancel
					</StyledButton>
					<StyledButton onClick={handleConfirm} color="primary" autoFocus>
						Ok
					</StyledButton>
				</DialogActions>
			</Dialog>

			<InfoSnackBar
				isOpen={snackOpen}
				onClose={handleSnackClose}
				message={isSuccess ? status.success : status.failure}
				severity={isSuccess ? "success" : "error"}
			/>
		</div>
	);
};
